import { Type } from "@angular/core";
import { AbstractColumn, ColumnType, ProcessingLocation } from "./table-column.model";
import { DynamicCell } from "../core/dynamic-cell.directive";
import { SizeWithCssUnit } from "@cdk";

export class ColumnBuilder {

  private _column: AbstractColumn;

  constructor(key: string) {

    if(key.length === 0) {
      throw new Error('Invalid key');
    }

    this._column = { key };
  }

  public setTitleToCapitalizedKey(): this {

    const old = this._column;
    const key = old.key;
    const title = `${key.at(0).toUpperCase()}${key.slice(1)}`
    this._column = {...old, title}
    return this;
  }

  public setTitle(title: string): this {

    const old = this._column;
    this._column = {...old, title}

    return this;
  }

  public setType(type: ColumnType): this {
    const old = this._column;
    this._column = {...old, type };
    return this;
  }

  public setCellTooltip(enabled: boolean): this {
    const old = this._column;
    this._column = { ...old, cellTooltipEnabled: enabled }
    return this;
  }

  public setCellEllipsisRows(rows: number): this {
    const old = this._column;
    this._column = { ...old , cellEllipsisRow: rows }
    return this;
  }

  public setDynamicCell(cell: Type<DynamicCell>): this {

    const old = this._column;
    this._column = { ...old, dynamicCellComponent: cell }

    return this;
  }

  public setFilterType(type: ProcessingLocation) {
    const old = this._column;
    this._column = { ...old, filter: type }

    return this;
  }

  public setSortType(type: ProcessingLocation) {
    const old = this._column;
    this._column = { ...old, sort: type }

    return this;
  }

  public setWidth(width: SizeWithCssUnit) {
    const old = this._column;
    this._column = { ...old, width }

    return this;
  }

  public setHidden() {
    const old = this._column;
    this._column = { ...old, display: 'hidden' };

    return this;
  }

  public setTypeTextWithServerSideFilteringAndSorting(): this {

    this.setType('text')
      .setFilterType('server-side')
      .setSortType('server-side');

    return this;
  }

  public setTypeTextWithOneLineAndTooltipWithClientFilter(): this {

    this.setType('text')
      .setFilterType('client-side')
      .setCellTooltip(true)
      .setCellEllipsisRows(1)

    return this;
  }

  build(): AbstractColumn {
    return this._column;
  }
}
